import MobileKeyboard from './MobileKeyboard';

export default MobileKeyboard;
